<template>
  <div v-if="participation">
    <div v-if="participation.signature?.signedDate" class="alert alert-success d-flex align-items-center gap-2">
      <i class="fa-solid fa-circle-check fa-lg"></i>
      <span>Document signé le {{ formatDate(participation.signature.signedDate,'DD/MM/YYYY') }}. Vous pouvez passer à l'étape suivante.</span>
    </div>
    <div v-else-if="signingUrl">
      <p class="text-muted mb-3">
        Veuillez lire et signer le document ci-dessous :
      </p>
      <div v-if="participation.signature?.signedDate" class="alert alert-success mt-3 d-flex align-items-center gap-2">
        <i class="fa-solid fa-circle-check fa-lg"></i>
        <span>Signature effectuée. Vous pouvez passer à l'étape suivante.</span>
      </div>
      <div class="ratio" style="width: 100%; min-height: 800px;  border: none;">
        <iframe
          :src="signingUrl"
          allow="camera;microphone;clipboard-write"
          title="Signature du document"
          class="rounded border"
          style="width: 100%; min-height: 800px;  border: none;"
        ></iframe>
      </div>
    </div>

    <div v-else-if="loading" class="text-center py-5">
      <div class="spinner-border text-primary" role="status"></div>
      <p class="mt-2 text-muted">Chargement de l'espace de signature...</p>
    </div>

    <div v-else-if="error" class="alert alert-danger">
      <i class="fa-solid fa-triangle-exclamation text-danger me-2"></i>{{ error }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted, computed } from 'vue';
import travelApi from '@/api/travelApi';
import { useField } from 'vee-validate';
import { formatDate } from '@/compositions/helper';
import { useUserStore } from '@/stores/userStore';

const userStore = useUserStore();

const participation = defineModel<UserParticipation>({ required: true });
const { value: signatureValue, setValue: setSignature } = useField<UserParticipationSignature>(() => 'signature');

const loading = ref(true);
const error = ref<string | null>(null);
const signingUrl = ref<string | null>(null);

const isValidated = computed(() => {
  return participation.value.signature?.signedDate != null || (userStore.isImpersonated && (userStore.connectedUser?.isAdmin == true));
});

defineExpose({ isValidated });

const onMessage = (event: MessageEvent) => {
  if (event.origin !== 'https://app.firma.dev') return;

  const data = event.data;
  if (data?.type === 'signing.completed' || data === 'signing.completed') {
    if (participation.value) {
      const temp_signature = signatureValue.value || {} as UserParticipationSignature;
      temp_signature.signedDate = new Date();
      setSignature(temp_signature);
    }
  }
};

onMounted(async () => {

  try {
    if(participation.value.travel.id && participation.value.travel.firmaTemplateId && !participation.value.signature?.signedDate)
    {
      const response = await travelApi.initiateSignature(participation.value.travel.id);
      if (response.data.signedDate) {
        const temp_signature = <UserParticipationSignature>{};
        temp_signature.signedDate = response.data.signedDate;
        setSignature(temp_signature);
      } else if (response.data.signingUrl) {
        window.addEventListener('message', onMessage);
        signingUrl.value = response.data.signingUrl;
      }
    }
  } catch {
    error.value = 'Impossible de charger l\'espace de signature. Veuillez réessayer.';
  } finally {
    loading.value = false;
  }
});

onUnmounted(() => {
  window.removeEventListener('message', onMessage);
});
</script>
